import { BLOCK_ROLE } from '../Page/Blocks/Text';
import { TPagesFilterFn } from './types';

export const ALLOWED_BLOCK_TYPES = ['header', 'text', 'list', 'accordion', 'document'];

export const TYPES_COLLECTION = [
  'unstyled',
  'left',
  'right',
  'center',
  'justify',
  'unordered-list-item',
  'ordered-list-item',
];

export const RAW_PARAGRAPH = {
  type: 'text',
  role: BLOCK_ROLE.PARAGRAPH,
};

export const defaultPagesFilterFn: TPagesFilterFn = () => true;
